<template>
  <v-container>
    <equipment-tab></equipment-tab
    ><v-container fluid v-if="grupos && grupos.length > 0">
      <navigation-drawer
        :drawer="drawer"
        @set-item="setCurrentItem"
        :grupos="grupos"
        :currentItem="currentItem"
        :equipmentProfile="equipmentProfile"
        @update-drawer="updateDrawer"
      ></navigation-drawer>

      <template v-if="currentItem.type === 'steps'">
        <div
          :class="
            $vuetify.theme.isDark
              ? 'headline my-4 text-no-wrap font-weight-bold'
              : 'headline my-4 text-no-wrap font-weight-bold primary--text'
          "
        >
          {{ currentItem.tagName && `${currentItem.tagName} &mdash;` }}
          {{ $t(`variables.${currentItem.name}`) }}
          &mdash;

          <br class="hidden-md-and-up" />
          <v-btn @click.stop="drawer = !drawer" color="primary">
            <v-icon>mdi-plus</v-icon>
            Variables
          </v-btn>
        </div>
        <apexchart
          type="line"
          height="350"
          :options="chartOptions(currentItem)"
          :series="mapSteps(currentItem)"
        ></apexchart>
      </template>
      <template v-else>
        <div
          :class="
            $vuetify.theme.isDark
              ? 'headline my-4 text-no-wrap font-weight-bold'
              : 'headline my-4 text-no-wrap font-weight-bold primary--text'
          "
        >
          {{ currentItem.tagName && `${currentItem.tagName} &mdash;` }}
          {{ $t(`variables.${currentItem.name}`) }}
          &mdash;

          <br class="hidden-md-and-up" />
          <v-btn @click.stop="drawer = !drawer" color="primary">
            <v-icon>mdi-plus</v-icon>
            Variables
          </v-btn>
        </div>

        <apexchart
          height="400"
          width="100%"
          type="line"
          :options="options(currentItem)"
          :series="mapVariable(currentItem)"
        ></apexchart>
      </template>
    </v-container>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { unitDefault } from "@/settings/unitTypes";
import readValues from "@/mixins/readValues";
import _ from "lodash";
import NavigationDrawer from "./NavigationDrawer.vue";
export default {
  components: { NavigationDrawer },
  mixins: [readValues],

  data() {
    return {
      currentItem: null,
      drawer: false
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square",
      text: ""
    });
    try {
      await this.$store.dispatch(
        "equipments/bindAnEquipment",
        this.$route.params.id
      );
      await this.$store.dispatch(
        "inspections/bindInspectionsOfEquipment",
        this.$route.params.id
      );
      this.currentItem = this.grupos[0];
      loading.close();
    } catch (error) {
      this.$dialog.notify.error(error, {
        position: "top-right",
        timeout: 5000
      });
    }
  },

  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("inspections", ["inspections"]),
    ...mapGetters("auth", ["isMetric", "isMetax", "adminAndUp"]),
    inspecciones() {
      let data = _.chain(this.inspections)
        .map(d => {
          let variables = _.chain(d.data)
            .map(e => {
              let item = e.variables.map(i => {
                i.date = d.dateCreated;
                i.id = d.id;
                return i;
              });
              return item;
            })
            .flatten()
            .value();
          return variables;
        })
        .flatten()
        .value();

      return data;
    },
    grupos() {
      let data = _.chain(this.inspecciones)
        .groupBy("code")
        .map((value, key) => {
          const variable = this.equipmentProfile?.variables?.find(
            v => v.code === key
          );

          return {
            name: key,
            tagName: variable?.tagName || "",
            value: value,
            type: variable?.type || "pressure"
          };
        })
        .value();

      return data;
    },
    compressor1StageTemp() {
      let result = _.chain(this.inspecciones)
        .filter(d => d.code === "compressor1StageTemp")
        .map(d => {
          return [
            {
              name: "compressor1StageTemp",
              type: d.type,
              unit: d.unit,
              data: [d.date.seconds * 1000, d.value.toFixed(0)]
            }
          ];
        })
        .flatten()
        .value();
      return result;
    }
  },

  methods: {
    chartOptions(item) {
      const { $dialog, $router } = this;
      const type = this.unit(item.value[0].type);
      let arrayValues = this.equipmentProfile?.variables?.find(
        v => v.code === item.name
      ).values;

      return {
        chart: {
          background: this.$vuetify.theme.dark ? "#3e3e3e" : "#FFFFFF",
          id: item.name,
          events: {
            async click(event, chartContext, config) {
              const isShiftPulsed = event.shiftKey;
              if (isShiftPulsed) {
                const res = await $dialog.confirm({
                  text: "Do you want to go to this Inspection?",
                  title: "Please Confirm"
                });
                if (res) {
                  $router.push({
                    name: "InspectionProfile",
                    params: {
                      id:
                        config.config.series[config.seriesIndex].data[
                          config.dataPointIndex
                        ][2]
                    }
                  });
                }
              }
            }
          }
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            function formatter(value) {
              let newValue = arrayValues.find(v => v.value === value);

              newValue = newValue.name;
              return newValue;
            }
            return `<div class="pa-4">
              ${w.config.series[0].name}
              :
              ${formatter(series[seriesIndex][dataPointIndex])} ${type}
              </div>`;
          }
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light",
          monochrome: {
            enabled: true,
            color: "#255aee",
            shadeTo: "light",
            shadeIntensity: 0.65
          }
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label"
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0,
            formatter: value => {
              let newValue = arrayValues.find(v => v.value == value);

              newValue = newValue?.name;
              return newValue;
            }
          }
        },
        xaxis: {
          type: "datetime"
        },
        stroke: {
          curve: "stepline"
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          hover: {
            sizeOffset: 4
          }
        },
        noData: {
          text: "There is no data for this API",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined
          }
        }
      };
    },
    unit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    },
    readValue(variable) {
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(
          this.transformUnit(variable?.value, variable?.type, unit)
        );
      }
    },

    readSmooth1(variable) {
      const rango = this.equipmentProfile?.variables?.find(
        v => v.code === variable.code
      );
      if (this.isMetric) {
        return parseFloat(rango.values[1]);
      } else {
        let unit = this.unit(rango?.type);
        return parseFloat(
          this.transformUnit(rango.values[1], rango?.type, unit).toFixed(2)
        );
      }
    },
    readSmooth2(variable) {
      const rango = this.equipmentProfile?.variables?.find(
        v => v.code === variable.code
      );
      if (this.isMetric) {
        return parseFloat(rango.values[2]);
      } else {
        let unit = this.unit(rango?.type);
        return parseFloat(
          this.transformUnit(rango.values[2], rango?.type, unit).toFixed(2)
        );
      }
    },
    readWarning1(variable) {
      const rango = this.equipmentProfile?.variables?.find(
        v => v.code === variable.code
      );
      if (this.isMetric) {
        return parseFloat(rango.values[1]);
      } else {
        let unit = this.unit(rango?.type);
        return parseFloat(
          this.transformUnit(rango.values[1], rango?.type, unit).toFixed(2)
        );
      }
    },
    readWarning2(variable) {
      const rango = this.equipmentProfile?.variables?.find(
        v => v.code === variable.code
      );
      if (this.isMetric) {
        return parseFloat(rango.values[3]);
      } else {
        let unit = this.unit(rango?.type);
        return parseFloat(
          this.transformUnit(rango.values[3], rango?.type, unit).toFixed(2)
        );
      }
    },
    readAlarm1(variable) {
      const rango = this.equipmentProfile?.variables?.find(
        v => v.code === variable.code
      );
      if (this.isMetric) {
        return parseFloat(rango.values[0]);
      } else {
        let unit = this.unit(rango?.type);
        return parseFloat(
          this.transformUnit(rango.values[0], rango?.type, unit).toFixed(2)
        );
      }
    },
    readAlarm2(variable) {
      const rango = this.equipmentProfile?.variables?.find(
        v => v.code === variable.code
      );
      if (this.isMetric) {
        return parseFloat(rango.values[3]);
      } else {
        let unit = this.unit(rango?.type);
        return parseFloat(
          this.transformUnit(rango.values[3], rango?.type, unit).toFixed(2)
        );
      }
    },
    readMin(arrayValues) {
      let { min } = this.equipmentProfile?.variables?.find(
        v => v.code === arrayValues[0].code
      );

      arrayValues.forEach(v => {
        const isLessThanMin = v.value < min;
        if (isLessThanMin) {
          min = v.value;
        }
      });
      if (min == 0) {
        min = -5;
      } else {
        const percentToGet = min * 0.1;
        min = min - percentToGet;
      }

      if (this.isMetric) {
        return parseFloat(min);
      } else {
        const unit = this.unit(arrayValues[0].type);
        return parseFloat(
          this.transformUnit(min, arrayValues[0].type, unit).toFixed(2)
        );
      }
    },
    setCurrentItem(payload) {
      this.currentItem = payload;
      this.drawer = false;
    },
    updateDrawer(payload) {
      this.drawer = payload;
    },
    readMax(arrayValues) {
      let { max } = this.equipmentProfile?.variables?.find(
        v => v.code === arrayValues[0].code
      );
      arrayValues.forEach(v => {
        const isMoreThanMax = v.value > max;
        if (isMoreThanMax) {
          max = v.value;
        }
      });
      const percentToGet = max * 0.1;
      max = max + percentToGet;
      if (this.isMetric) {
        return parseFloat(max);
      } else {
        const unit = this.unit(arrayValues[0].type);
        return parseFloat(
          this.transformUnit(max, arrayValues[0].type, unit).toFixed(2)
        );
      }
    },

    options(item) {
      const arrayValues = item.value;
      const type = this.unit(item.value[0].type);
      const { $dialog, $router } = this;
      return {
        chart: {
          background: this.$vuetify.theme.dark ? "#3e3e3e" : "#FFFFFF",
          id: item.name,
          events: {
            async click(event, chartContext, config) {
              const isShiftPulsed = event.shiftKey;
              if (isShiftPulsed) {
                const res = await $dialog.confirm({
                  text: "Do you want to go to this Inspection?",
                  title: "Please Confirm"
                });
                if (res) {
                  $router.push({
                    name: "InspectionProfile",
                    params: {
                      id:
                        config.config.series[config.seriesIndex].data[
                          config.dataPointIndex
                        ][2]
                    }
                  });
                }
              }
            }
          }
        },

        xaxis: {
          type: "datetime"
        },
        stroke: {
          curve: "smooth"
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return `<div class="pa-4">
              ${w.config.series[0].name}
              :
              ${series[seriesIndex][dataPointIndex]} ${type}
              </div>`;
          }
        },

        annotations: {
          yaxis: [
            {
              y: this.readSmooth1(item.value[0]),
              y2: this.readWarning2(item.value[0]),
              borderColor: "#efb700",
              fillColor: "#efb700",
              opacity: 0.3
            },
            {
              y: this.readAlarm1(item.value[0]),
              y2: this.readWarning1(item.value[0]),
              borderColor: "#efb700",
              fillColor: "#efb700",
              opacity: 0.3,
              label: {
                borderColor: "#efb700",
                style: {
                  background: "#efb700"
                },
                text: "Warning"
              }
            },
            {
              y: this.readSmooth1(item.value[0]),
              y2: this.readSmooth2(item.value[0]),
              borderColor: "#008450",
              fillColor: "#008450",
              opacity: 0.3,
              label: {
                borderColor: "#008450",
                style: {
                  background: "#008450"
                },
                text: "Smooth"
              }
            },
            {
              y: this.readAlarm2(item.value[0]),
              y2: this.readMax(arrayValues),

              borderColor: "#b81d13",
              fillColor: "#b81d13",
              opacity: 0.3,
              label: {
                borderColor: "#b81d13",
                style: {
                  background: "#b81d13"
                },
                text: "Alarm"
              }
            },
            {
              y: this.readAlarm1(item.value[0]),
              y2: this.readMin(arrayValues),
              borderColor: "#b81d13",
              fillColor: "#b81d13",
              opacity: 0.3,
              label: {
                borderColor: "#b81d13",
                style: {
                  background: "#b81d13"
                },
                text: "Alarm"
              }
            }
          ]
        },
        yaxis: {
          min: this.readMin(arrayValues),
          max: this.readMax(arrayValues)
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light",
          monochrome: {
            enabled: true,
            color: "#255aee",
            shadeTo: "light",
            shadeIntensity: 0.65
          }
        },
        noData: {
          text: "There is no data for this API",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined
          }
        }
      };
    },
    mapSteps(item) {
      let result = _.chain(item.value)
        .sortBy(e => e.date.seconds * 1000)
        .flatten()
        .flatten()
        .map(e => [new Date(e.date.seconds * 1000), e.value.value, e.id])
        .value();

      let response = [];
      response.push({
        name: this.$t(`variables.${item.name}`),
        data: result
      });
      return response;
    },
    mapVariable(item) {
      let result = _.chain(item.value)
        .sortBy(e => e.date.seconds * 1000)
        .flatten()
        .flatten()
        .map(e => [
          new Date(e.date.seconds * 1000),
          this.readValue(e).toFixed(2),
          e.id
        ])
        .value();

      let response = [];
      response.push({
        name: this.$t(`variables.${item.name}`),
        data: result
      });
      return response;
    }
  }
};
</script>
<style>
.apexcharts-tooltip {
  background: #121212;
  color: #121212;
}
</style>
